module.exports = __webpack_public_path__ + "img/53f3b6b.jpg";